import { FC } from 'react';
import PrivacyConsentMessage from './Messages/PrivacyTerms';
import PlainTextMessage from './Messages/PlainText';
import { ConsentType } from '../types';

interface IMessageFactoryProps {
    type: ConsentType;
    messageComponentProps?: any;
}

const MessageFactory: FC<IMessageFactoryProps> = ({ type, messageComponentProps }) => {
    switch (type) {
        case ConsentType.PlainText:
            return <PlainTextMessage text={messageComponentProps?.text} />;
        case ConsentType.Privacy:
            return (
                <PrivacyConsentMessage
                    modalCloseHandler={messageComponentProps?.modalCloseHandler}
                    className={messageComponentProps?.className}
                />
            );
        default:
            throw Error('Invalid Type');
    }
};

export default MessageFactory;
